import React, { Component } from 'react';
import dataModel from '../../models/DataModel';
import anime from 'animejs';
import ImageTools from '../../helpers/ImageTools';
import './CopyCompletionStepPopout.scss';
import Input from '../Input';

class CopyCompletionStepPopout extends Component {

  constructor(props) {
    super(props);
    this.state = {
      completionStep: props.completionStep,
      completionStepName: props.completionStep.name ? props.completionStep.name + ' (Copy)' : '',
      completionStepInstruction: props.completionStep.instructions ? props.completionStep.instructions + ' (Copy)' : '',
    };

    this.changeCompletionStepInfo = this.changeCompletionStepInfo.bind(this);
    this.closePopup = this.closePopup.bind(this);
    this.handleCompletionStepCopy = this.handleCompletionStepCopy.bind(this);
    this.collapsePopup = this.collapsePopup.bind(this);
  }

  componentDidUpdate() {

    if (this.props.displayCopyPopout) {
      this.expandPopup();
    }
  }

  expandPopup() {
    const height =  210;
    return anime({
      targets: this.copyCompletionStepPopout,
      height: height,
      easing: 'easeInOutCubic',
      duration: 200,
    });
  }

  resetState() {
    const { completionStep } = this.props;
    this.setState({
      completionStepName: completionStep.name ? completionStep.name + ' (Copy)' : '',
      completionStepInstruction: completionStep.instructions ? completionStep.instructions + ' (Copy)' : '',
    });
  }

  collapsePopup() {
    return anime({
      targets: this.copyCompletionStepPopout,
      height: 0,
      easing: 'easeInOutCubic',
      duration: 200,
      complete: () => {
        this.closePopup();
        this.resetState();
      },
    });
  }

  changeCompletionStepInfo(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  closePopup() {
    const { handleClosePopup } = this.props;
    if (handleClosePopup) {
      handleClosePopup();
    }
  }

  handleCompletionStepCopy(e) {
    e.stopPropagation();
    if(this.state.completionStepName && this.state.completionStepInstruction){
      const changedData = { 'name': this.state.completionStepName, 'instructions': this.state.completionStepInstruction };
      dataModel.completionCriteriaDAO.copyCompletionCriterion(this.state.completionStep, changedData);
      this.collapsePopup();
    }
  }

  render() {
    const { completionStepName, completionStepInstruction } = this.state;
    const cancelIcon = ImageTools.getCancelIcon('white');

    return (
      <article 
        className={'copy-completion-step-popout'}
        ref={el => this.copyCompletionStepPopout = el}
      >
        <header className='copy-completion-step-popout__header'>
          COPY Completion STEP
          <img 
            src={cancelIcon} 
            alt="cancel"
            className='close-button' 
            onClick={this.collapsePopup}
          />
        </header>
        <section className='copy-completion-step-popout__container'>
          <div className='completion-step-info'>
            <p className='completion-step-info__text'>COMPLETION STEP NAME</p>
            <Input 
              className='completion-step-info__input' 
              name='completionStepName'
              value={completionStepName}
              onChange={this.changeCompletionStepInfo}
            />
          </div> 
          <div className='completion-step-info'>
            <p className='completion-step-info__text'>COMPLETION STEP INSTRUCTION</p>
            <Input 
              className='completion-step-info__input' 
              name='completionStepInstruction'
              value={completionStepInstruction}
              onChange={this.changeCompletionStepInfo}
            />
          </div> 
        </section>
        <div className='copy-completion-step-popout__button-container'>
          <button className='copy-button' onClick={this.collapsePopup}>
            CANCEL
          </button>
          <button 
            className={'copy-button copy-button__copy' + (completionStepName && completionStepInstruction ? '-active' : '')}
            onClick={this.handleCompletionStepCopy}
          >
            COPY
          </button>
        </div>
      </article>
    );
  }
}

export default CopyCompletionStepPopout;



// WEBPACK FOOTER //
// ./src/components/CopyCompletionStepPopout/index.js